import { Card } from "@/components/ui/card"
import { AlertCircle } from "lucide-react"

interface OverviewTabProps {
  audioResult?: any
}

export function OverviewTab({ audioResult }: OverviewTabProps) {
  // Calculate pass/fail criteria counts from scenario details
  const passCount = audioResult?.scenario_details?.filter((s: any) => s.verdict === "PASS").length || 0
  const failCount = audioResult?.scenario_details?.filter((s: any) => s.verdict === "FAIL").length || 0
  // Calculate Pass and Fail Criteria Scores
  const passCriteriaScore = passCount * 10
  const failCriteriaScore = failCount * 10
  // Total Score = Pass Criteria Score + Fail Criteria Score
  const totalScore = passCriteriaScore + failCriteriaScore

  // Determine if there's a failure reason
  const failedScenarios = audioResult?.scenario_details?.filter((s: any) => s.verdict === "FAIL") || []
  const failureReason = failedScenarios.length > 0 
    ? failedScenarios[0].feedback?.summary || failedScenarios[0].reasoning?.join(" ") || "Evaluation criteria not met"
    : null

  return (
    <div className="space-y-6">
      {audioResult?.verdict === "FAIL" && failureReason && (
        <div className="flex items-start gap-3 p-4 rounded-lg bg-error/30 border border-error">
          <AlertCircle className="w-5 h-5 text-error-foreground flex-shrink-0 mt-0.5" />
          <div>
            <div className="font-medium text-error-foreground mb-1">
              This conversation failed with the following reason:
            </div>
            <div className="text-sm text-error-foreground">
              {failureReason}
            </div>
          </div>
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Card className="p-6 border border-border bg-white rounded-lg">
          <div className="text-sm text-muted-foreground mb-2">Total Score</div>
          <div className="text-3xl font-bold text-foreground">{totalScore}</div>
        </Card>

        <Card className="p-6 border border-border bg-white rounded-lg">
          <div className="text-sm text-muted-foreground mb-2">Pass Criteria Score</div>
          <div className="text-3xl font-bold text-success">{passCriteriaScore}</div>
        </Card>

        <Card className="p-6 border border-border bg-white rounded-lg">
          <div className="text-sm text-muted-foreground mb-2">Fail Criteria Score</div>
          <div className="text-3xl font-bold text-error">{failCriteriaScore}</div>
        </Card>
      </div>

      <Card className="p-6 border border-border bg-white rounded-lg">
        <h3 className="font-semibold text-foreground text-base mb-4">Analytics</h3>
        <div className="text-foreground leading-relaxed text-sm whitespace-pre-wrap font-mono text-xs bg-gray-50 p-4 rounded border">
          {audioResult?.scenario_details?.[0]?.feedback?.analysis || 
           audioResult?.scenario_details?.[0]?.feedback?.summary ||
           "No analysis available for this conversation."}
        </div>
      </Card>
    </div>
  )
}

